<template>
    <footer class="more-information">
        <div class="container">
            <h2 data-aos="fade-up" data-aos-delay="100">{{$t('component.moreInfo')}}</h2>
            <div class="btn-hover">
                <a  data-aos="fade-up" data-aos-delay="200" @click="showModal()" class="btn red-border">{{$t('component.askAboutMore')}} <span/></a>
            </div>
        </div>
    </footer>
</template>

<script>
    import store from '../store/store';
    export default {
        name: 'footer-more-information',
        props: ['modalpage'],
        data() {
            return {
                pageType: this.modalpage
            }
        },
        mounted: function(){

        },
        methods: {
            showModal: function() {
                store.commit('SET_MODAL', {visible: true, questionName: this.modalpage});
            }
        },
        
        computed: {
            lang: () => {
                return store.state.lang;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// FooterMoreInformation.vue?19b388b3